import { Box, Typography } from '@mui/material'
import { HowWorksVideo } from 'assets'
import { LandingButton } from 'components'
import { COLORS } from 'const'
import { motion } from 'framer-motion'
import { useDataLanding } from 'hooks'
import { useState } from 'react'
import {
  containerVariants,
  landingButtonPrimary,
  howWorksContainer,
  howWorksContent,
  videoContainer,
  videoPreview,
  playButton,
  playIcon,
  videoIframe,
  howWorksTextContainer,
  sectionTitleResponsiveH3,
  sectionDescriptionResponsive,
} from 'styles'

export const HowWorksSection = () => {
  const { content } = useDataLanding()
  const [showVideo, setShowVideo] = useState(false)

  const youtubeVideoId = content?.howWorks?.youtubeVideoId

  const handlePlayClick = () => {
    setShowVideo(true)
  }

  return (
    <Box id="howWorks" sx={howWorksContainer}>
      <Box
        sx={howWorksContent}
        component={motion.div}
        initial="offscreen"
        whileInView="onscreen"
        variants={containerVariants}
        viewport={{ once: true }}
      >
        <Box sx={videoContainer}>
          {!showVideo ? (
            <>
              <Box component="img" src={HowWorksVideo} alt="Video preview" sx={videoPreview} />
              <Box sx={playButton} onClick={handlePlayClick}>
                <Box component="span" sx={playIcon} />
              </Box>
            </>
          ) : (
            <Box
              component="iframe"
              src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&rel=0&modestbranding=1`}
              sx={videoIframe}
              title="Video de YouTube"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </Box>

        <Box sx={howWorksTextContainer}>
          <Typography
            variant="h3"
            sx={{
              ...sectionTitleResponsiveH3,
              color: COLORS.text.white,
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            {content?.howWorks?.title}
          </Typography>
          <Typography
            sx={{
              ...sectionDescriptionResponsive,
              color: COLORS.text.white,
              mb: 2,
            }}
          >
            {content?.howWorks?.description}
          </Typography>

          <LandingButton
            text={content?.howWorks?.buttonText || 'FIRMAR AHORA'}
            style={{
              ...landingButtonPrimary,
              backgroundColor: COLORS.button.second,
              borderRadius: '30px',
              px: 4,
              py: 1,
              width: 'fit-content',
            }}
            onClick={() => {
              window.open(
                process.env.REACT_APP_NUNA_PROCESS_ONBOARDING ?? content?.howWorks?.buttonLink,
                '_blank'
              )
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}
